<template>
    <div class="btn-group">
        <em-button
                custom-icon="fa fa-fw fa-lg fa-tasks"
                :disabled="selectedItems.length < 1"
                :busy="loading"
                type="check"
                class="btn btn-outline-primary btn-sm"
                custom-label="生成盘库任务"
                @click="createTask()"
                show-name
        />
        <em-button
                custom-icon="fa fa-fw fa-lg fa-print"
                :disabled="selectedItems.length < 1"
                :busy="loading"
                type="check"
                class="btn btn-outline-primary btn-sm"
                custom-label="usb批量打印rfid标签"
                @click="localPrintLabels()"
                show-name
        />
        <em-button
                custom-icon="fa fa-fw fa-lg fa-print"
                :disabled="selectedItems.length < 1"
                :busy="loading"
                type="check"
                class="btn btn-outline-primary btn-sm"
                custom-label="网络批量打印rfid标签"
                @click="netWorkPrintLabels()"
                show-name
        />
    </div>
</template>

<script>
import browserPrint from "@/mixin/common/browserPrinter-mixin";
import EmButton from "@/components/em/EmButton/index.vue";
export default {
    name: 'StockTaskPrint',
    components: {EmButton},
    mixins: [browserPrint],
    props: {
        selectedItems: {
            type: Array,
            required: true
        },
        tagBusinessCode: {
            type: Number,
            default: 1
        },
        tagMaterialId: {
            type: Number,
            default: 1
        },
        requestParam: {
            type: Array,
            required: true
        },
        printTemplate: {
            type: Function,
            default: (label, epcCode) =>
                    `^XA^RS8,2,5,10,1^RFW,H,0,24,^FD${epcCode}^FS^FO180,180^A0N,50,50^FD${label}^FS^PQ1^MNY^XZ`.trim()
        },
        printLabelText: {
            type: Function,
            default: item => item.code
        }
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        async createTask() {
            let finalRequest = {
                "taskBusinessType": this.tagBusinessCode,
                "taskDetailList": this.requestParam
            }
            this.loading = true;
            try {
                const res = await this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ARCHIVE_URL + '/emStocktakingTask/createStocktakeTask',
                    data: finalRequest
                });
                if (res&& res.data)  {
                    this.$message.success('生成任务成功');
                    this.$emit('taskCreatedSuccess', res.data);
                }
            } finally {
                this.loading = false;
            }
        },

        async localPrintLabels() {
            console.log("打印标签")
            this.initBrowserPrint()
            if (this.selectedItems.length < 1) {
                this.$message.warning('请选择要打印的行！');
                return;
            }

            const requestList = this.selectedItems.map(item => ({
                tagBusinessCode: this.tagBusinessCode,
                tagMaterialId: this.tagMaterialId,
                bindId: item.id
            }));

            this.loading = true;

            try {
                const res = await this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ARCHIVE_URL + '/emEpcTag/batchGenerateEpcCodeAndBind',
                    data: requestList
                });

                if (res&& res.data) {
                    const epcMap = {};
                    for (let epc of res.data) {
                        epcMap[epc.bindId] = epc.epcCode;
                    }

                    console.log("printLabelText:", this.printLabelText)
                    const zplList = this.selectedItems.map(item =>
                            this.printTemplate(this.printLabelText(item), epcMap[item.id])
                    );

                    this.$emit('sendZpl', zplList);
                    //使用事件传出 ZPL 列表
                    await this.sendMultipleZPLs(zplList)
                }
            } catch (err) {
                console.warn('标签生成失败:', err);
                this.$message.error('标签生成失败'+ err);
            } finally {
                this.loading = false;
                this.$emit('refresh');
            }
        },
        async netWorkPrintLabels() {
            if (this.selectedItems.length < 1) {
                this.$message.warning('请选择要打印的行！');
                return;
            }

            const requestList = this.selectedItems.map(item => ({
                tagBusinessCode: this.tagBusinessCode,
                tagMaterialId: this.tagMaterialId,
                bindId: item.id
            }));

            this.loading = true;

            try {
                const res = await this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ARCHIVE_URL + '/emEpcTag/batchGenerateEpcCodeAndBind',
                    data: requestList
                });

                if (res&& res.data) {
                    const epcMap = {};
                    for (let epc of res.data) {
                        epcMap[epc.bindId] = epc.epcCode;
                    }

                    console.log("printLabelText:", this.printLabelText)
                    const zplList = this.selectedItems.map(item =>
                            this.printTemplate(this.printLabelText(item), epcMap[item.id])
                    );

                    this.$emit('sendZpl', zplList);
                    const printRes = await this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_EM_ARCHIVE_URL + '/emEpcTag/zplPrintRfid',
                        data: {
                            'zplList': zplList
                        }

                    });
                    if (printRes&& printRes.data) {
                        this.$message.success('标签打印成功');
                    } else {
                        this.$message.error('标签打印失败:'+ printRes.message);
                    }
                }
            } catch (err) {
                console.warn('标签生成失败:', err);
                this.$message.error('标签生成失败'+ err);
            } finally {
                this.loading = false;
                this.$emit('refresh');
            }
        }
    }
};
</script>
